import React from "react";
export const TiktokFilled = ({
  size = 20
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: `${size}px`,
    height: `${size}px`,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 4H9C6.243 4 4 6.243 4 9V41C4 43.757 6.243 46 9 46H41C43.757 46 46 43.757 46 41V9C46 6.243 43.757 4 41 4ZM37.006 22.323C36.779 22.344 36.549 22.358 36.316 22.358C33.693 22.358 31.388 21.009 30.047 18.97C30.047 24.319 30.047 30.405 30.047 30.507C30.047 35.216 26.229 39.034 21.52 39.034C16.811 39.034 12.993 35.216 12.993 30.507C12.993 25.798 16.811 21.98 21.52 21.98C21.698 21.98 21.872 21.996 22.047 22.007V26.209C21.872 26.188 21.7 26.156 21.52 26.156C19.116 26.156 17.168 28.104 17.168 30.508C17.168 32.912 19.116 34.86 21.52 34.86C23.924 34.86 26.047 32.966 26.047 30.562C26.047 30.467 26.089 10.968 26.089 10.968H30.105C30.483 14.559 33.382 17.393 37.006 17.653V22.323Z",
    fill: "currentColor"
  }));
};
//# sourceMappingURL=TiktokFilled.js.map